/**
 * Spoken trigger for AI Voice Editing while dictating in the CRE editor:
 * "ערוך דוח" (also "ערוך את הדוח", with דו"ח / דו״ח spellings) and "Edit report".
 */

const TRIGGERS = [
  // Hebrew: ערוך [את ה]דוח / דו"ח / דו״ח
  /(^|[\s.,;:!?])(ערוך\s+(?:את\s+)?ה?דו["״׳']?ח)(?=$|[\s.,;:!?])/u,
  // English: edit [the] report
  /(^|[\s.,;:!?])(edit\s+(?:the\s+)?report)(?=$|[\s.,;:!?])/iu,
];

/**
 * @param {string} text one final STT segment
 * @returns {{ before: string, after: string } | null} text before the trigger
 *   (normal dictation) and after it (the start of the edit instruction)
 */
export function findEditReportTrigger(text) {
  const value = String(text || "");
  for (const re of TRIGGERS) {
    const m = re.exec(value);
    if (!m) continue;
    const start = m.index + m[1].length;
    const end = start + m[2].length;
    return {
      before: value.slice(0, start).replace(/[\s,;:]+$/u, ""),
      after: value.slice(end).replace(/^[\s.,;:!?]+/u, "").trim(),
    };
  }
  return null;
}
